import { Pipe, PipeTransform } from '@angular/core';
import { TimezoneService } from '../../core/services/timezone.service';

@Pipe({
  name: 'localDateTime',
  standalone: false,
})
export class LocalDateTimePipe implements PipeTransform {
  constructor(private readonly timezoneService: TimezoneService) {}

  transform(value: string | null | undefined, timezone?: string | null, locale = 'en-US'): string {
    const normalized = `${value || ''}`.trim();
    if (!normalized) {
      return '';
    }

    const formatted = this.timezoneService.formatUtcForDisplay(normalized, timezone, locale);
    return formatted || normalized;
  }
}
